import React, { FC, useEffect, useState } from 'react'

import { Grid, Theme, useMediaQuery, useTheme } from '@mui/material'
import { isEmpty, isEqual } from 'lodash'

import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import { fetchTimeReport } from '../ReportsSlice'

import { TradeDistributionWidget } from './TradeDistributionWidget'
import { WinLossMoneyWidget } from './WinLossMoneyWidget'
import { WinLossNumberWidget } from './WinLossNumberWidget'

export const TimeReports: FC = () => {
  const { spacing } = useTheme()
  const dispatch = useAppDispatch()

  const [displayWidth, setDisplayWidth] = useState(window.innerWidth)

  const matchesBreakpoints: boolean = useMediaQuery((theme: Theme) => theme.breakpoints.up(2000))

  const { time } = useAppSelector(({ reports }) => reports)
  const { period, currentAccount } = useAppSelector(({ userAccounts }) => userAccounts)

  useEffect(() => {
    const periodsIsEqual = time?.meta?.period && period && isEqual(time.meta.period, period)
    const isNeedToUpdate =
      isEmpty(time) || !periodsIsEqual || currentAccount?.id !== time?.meta.account

    if (currentAccount?.id && isNeedToUpdate) {
      dispatch(
        fetchTimeReport({
          account: currentAccount?.id,
          period: period,
        }),
      )
    }
  }, [period, currentAccount])

  useEffect(() => {
    const handleResize = () => {
      setDisplayWidth(window.innerWidth)
    }
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <Grid container spacing={2}>
      <Grid
        item
        xs={12}
        sm={12}
        md={6}
        lg={matchesBreakpoints ? 4 : 6}
        // height={spacing(42.25)}
        sx={{
          pageBreakInside: 'avoid',
          display: 'flex',
          flexDirection: 'column',
          minHeight: { xs: spacing(35), sm: spacing(38), md: spacing(42.25) },
        }}
      >
        <WinLossNumberWidget data={time?.winLossAmount} displayWidth={displayWidth} />
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={6}
        lg={matchesBreakpoints ? 4 : 6}
        sx={{
          pageBreakInside: 'avoid',
          display: 'flex',
          flexDirection: 'column',
          minHeight: { xs: spacing(35), sm: spacing(38), md: spacing(42.25) },
        }}
      >
        <TradeDistributionWidget data={time?.tradeDistribution} displayWidth={displayWidth} />
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={6}
        lg={matchesBreakpoints ? 4 : 6}
        sx={{
          pageBreakInside: 'avoid',
          display: 'flex',
          flexDirection: 'column',
          minHeight: { xs: spacing(35), sm: spacing(38), md: spacing(42.25) },
        }}
      >
        <WinLossMoneyWidget
          data={time?.winLossAmount}
          currency={currentAccount?.currency}
          displayWidth={displayWidth}
        />
      </Grid>
    </Grid>
  )
}
